import styled from "styled-components";
import {device} from "../helper/constants";

const Wrapper = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    @media ${device.mobile} {
        width: 100%;
        flex-direction: column;
    }
`;
const TextWrapper = styled.div`
    padding: 30px;
    font-size: 22px;
    color: #144344;
    font-weight: bold;
`;

const ButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
  
    & button {
        height: 40px;
        display: flex;
        align-items: center;
    }
    & button:hover {
        color: white;
    }
    & a {
        color: #144344;
        font-weight: bold;
        text-decoration: underline;
    }
`;
export default function Devis ({message}) {

    const askDevis = () => {
        window.location.href = "/contact";
    }
    return (
        <Wrapper>
            <TextWrapper>{message}</TextWrapper>
            <ButtonContainer>
                <button onClick={askDevis}>Demandez un devis</button>
                <a href="tel:0185490021">Appelez-nous</a>
            </ButtonContainer>

        </Wrapper>
    )
}